import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';

import { APIBusinessMe } from './api_business_auth';


export const AdvertiserContext = createContext(null);
export const useAdvertiser = () => useContext(AdvertiserContext);

const COOKIE_NAME = 'advertiserToken';


/**
 * Контур рекламодателя. Отдельная кука и отдельный scope в JWT:
 * токеном партнёра или админа сюда войти нельзя, и наоборот.
 */
export default function AdvertiserProvider({ children }) {
    const [advertiserToken, setAdvertiserToken] = useState(() => Cookies.get(COOKIE_NAME) || null);
    const [advertiser, setAdvertiser] = useState(null);
    const [authStatus, setAuthStatus] = useState('loading'); // loading | authorized | guest

    const loadAdvertiser = useCallback(async (token) => {
        try {
            const res = await APIBusinessMe(token);
            setAdvertiser(res?.advertiser || null);
            setAuthStatus('authorized');
        } catch (e) {
            // 403 с кодом email_not_verified — токен валиден, но кабинет закрыт.
            // Разлогинивать в этом случае нельзя, иначе пользователь
            // не увидит объяснения и будет ходить по кругу.
            if (e?.response?.status === 403 && e?.response?.data?.code === 'email_not_verified') {
                setAdvertiser(null);
                setAuthStatus('unverified');
                return;
            }
            Cookies.remove(COOKIE_NAME);
            setAdvertiserToken(null);
            setAdvertiser(null);
            setAuthStatus('guest');
        }
    }, []);

    useEffect(() => {
        if (!advertiserToken) { setAuthStatus('guest'); return; }
        loadAdvertiser(advertiserToken);
    }, [advertiserToken, loadAdvertiser]);

    const applyLoginSuccess = useCallback((token, advertiserData) => {
        Cookies.set(COOKIE_NAME, token, { expires: 30, sameSite: 'Lax' });
        setAdvertiserToken(token);
        setAdvertiser(advertiserData || null);
        setAuthStatus('authorized');
    }, []);

    const logout = useCallback(() => {
        Cookies.remove(COOKIE_NAME);
        setAdvertiserToken(null);
        setAdvertiser(null);
        setAuthStatus('guest');
    }, []);

    const value = {
        advertiserToken,
        advertiser,
        authStatus,
        applyLoginSuccess,
        logout,
        reloadAdvertiser: () => advertiserToken && loadAdvertiser(advertiserToken),
    };

    return (
        <AdvertiserContext.Provider value={value}>
            {children}
        </AdvertiserContext.Provider>
    );
}